/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import LeftNavCommonUI from '@components/UI/Common/LeftNavCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import SPBanner from '@landing_pages/Sadhanapada/HeaderBanner/SPBanner';
import WrapLayout from '@Layout/WrapLayout';

import { getLocale } from '@components/Utility/Shared/SharedService';

/* Services */
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData, filterBuildUrls,
    getLatestBuild
} from 'services/commonService';
import { fetchDetails } from 'services/sadhanapadaService';

/**
 * Renders the Sadhanapada Landing Page
 *
 * @function
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} headerMenuData - Header Menu Options
 * @param {string} pageData - Sadhanapada Landing Page Data
 * @param {string} footerData - Page Footer Data
 * @param {string} p<Box float="left" w="100%" pos="relative" height="600px">
          <Box float="left" w="100%" pos="relative">

          </Box>
      </Box>age - Page Name
 * @returns {ReactElement} Sadhanapada Landing Page
 */

const Sadhanapada = ({ pageData, region, language }) => {
  const renderCenterContent = () => {
    return (
      pageData &&
      pageData?.body?.map((section, i) => {
        if (section.value[i].sectionId === 'top-banner') {
          return (
            <SPBanner
              sectionContent={section.value[i]}
              region={region}
              lang={language}
            ></SPBanner>
          );
        }
      })
    );
  };

  return (
    <>
      <WrapLayout pad={0}>
        <HeadComponent
          data={pageData?._seoMetaTags || pageData?.seoFields}
          availableLocals={pageData.availableLocales}
        />
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={region}
          lang={language}
          pageConfig={pageData?.pageConfig}
        />
        <Box as="div" className="sp_banner">
          {renderCenterContent()}
        </Box>
        <Box as="section" p="0" className="page-wrap centerContent" mb="40px">
          <LeftNavCommonUI
            pageBody={pageData.bodyLeftNavSections}
            region={region}
            lang={language}
            isLeftMenu={true}
            pageName="Sadhanapada"
          />
        </Box>
      </WrapLayout>

      <style global jsx>{`
        .centerContent {
          clear: both;
        }
        #program-highlights {
          margin-bottom: 20px;
        }
        #apply-now a h2 {
          font-family: 'FedraSansStd-book';
          text-decoration: none;
          text-align: center;
        }
        #apply-now a:hover {
          text-decoration: none !important;
        }
        @media only screen and (max-width: 767px) {
          // #card3 {
          //   margin: 24px 16px 0;
          // }
        }
        @media only screen and (max-width: 360px) {
          #card3 {
            margin: 24px 0;
          }
        }
      `}</style>
    </>
  );
};

export const getStaticPaths = async () => {
  let sadhanaLandingPaths =
    config.USE_LOCAL_URL || config.BUILD_URLS?.LANDING_PAGES?.Sadhanapada
      ? ['/in/en/volunteer/sadhanapada', '/in/ta/volunteer/sadhanapada']
      : [];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    sadhanaLandingPaths = filterBuildUrls(
      `landing_page_child`,
      `L1`,
      '/volunteer/sadhanapada',
      '',
      data
    );
    // consoleLog('sadhanaLandingPaths', sadhanaLandingPaths);
  }
  return {
    paths: sadhanaLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  params: { region, language }
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language);
  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'Sadhanapada'
    }
  };
};

export default Sadhanapada;
